import type { ItemType } from 'venn-ui-kit';
import { Icon, ItemIcon } from 'venn-ui-kit';
import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';

import React from 'react';
import type { LibrarySearchEntity } from 'venn-api';

const PortfolioIcon = ({
  itemType,
  lastSyncStatus,
  dataSource,
  accountStatus,
}: {
  itemType: ItemType;
  lastSyncStatus: LibrarySearchEntity['lastSyncStatus'];
  dataSource: LibrarySearchEntity['dataSource'];
  accountStatus: LibrarySearchEntity['accountStatus'];
}) => {
  switch (lastSyncStatus) {
    case 'FAILED':
      return (
        <Tooltip disableHoverableContent>
          <TooltipTrigger>
            <Icon className="fa-triangle-exclamation text-venn-error" />
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContentWithArrow>Sync failed. Consult your Admin to learn more</TooltipContentWithArrow>
          </TooltipPortal>
        </Tooltip>
      );

    case 'PARTIAL':
      return (
        <Tooltip disableHoverableContent>
          <TooltipTrigger>
            <Icon className="fa-diamond-exclamation text-venn-orange" />
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContentWithArrow>
              Portfolio data could not be fully synced at this time. Consult your Admin to learn more
            </TooltipContentWithArrow>
          </TooltipPortal>
        </Tooltip>
      );

    default:
      return <ItemIcon item={itemType} dataSource={dataSource} accountStatus={accountStatus} />;
  }
};

export default PortfolioIcon;
